import { TextField, Autocomplete, Box } from "@mui/material";

const MemberForm = ({
  data = {},
  isSmall,
  onChange,
  depts = [],
  years = [],
  type,
  error = {},
  disable,
}) => {
  // // console.log(years,depts);
  // // console.log(data.year);
  const rowStyle = {
    display: "flex",
    flexDirection: isSmall ? "column" : "row",
    gap: "10px",
    marginBottom: "10px",
  };

  const inputSty = {
    width: isSmall ? "100%" : "23%",
    marginLeft: isSmall ? "8px" : 0,
  };

  const members = ["TeamLead", "Member1", "Member2", "Member3"];

  return (
    <>
      {type ? (
        <Box sx={rowStyle}>
          {members.map((member, i) => (
            <TextField
              key={i}
              label={`${member} RegNo`}
              size="small"
              margin="dense"
              value={data?.[member] || ""}
              onChange={(e) => onChange(member, e.target.value)}
              sx={inputSty}
              InputLabelProps={{ sx: { fontWeight: "bold" } }}
              error={!!error[member]}
              disabled={member === "TeamLead" ? !disable : disable}
            />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <TextField
            label="Name"
            size="small"
            margin="dense"
            value={data?.name || ""}
            onChange={(e) => onChange("name", e.target.value)}
            sx={inputSty}
            InputLabelProps={{ sx: { fontWeight: "bold" } }}
            // disabled
          />

          <TextField
            label="Register Number"
            type="number"
            size="small"
            margin="dense"
            value={data?.reg_no || ""}
            onChange={(e) => onChange("reg_no", e.target.value)}
            sx={inputSty}
            InputLabelProps={{ sx: { fontWeight: "bold" } }}
            // disabled
          />

          <Autocomplete
            disablePortal
            value={data?.dept ?? null}
            options={depts}
            sx={inputSty}
            onChange={(_, newValue) => onChange("dept", newValue ?? "")}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                margin="dense"
                label="Dept"
                InputLabelProps={{ sx: { fontWeight: "bold" } }}
              />
            )}
            // disabled
          />

          <Autocomplete
            disablePortal
            value={data?.year ?? null}
            options={years}
            sx={inputSty}
            onChange={(_, newValue) => onChange("year", newValue ?? "")}
            renderInput={(params) => (
              <TextField {...params} label="Year" size="small" />
            )}
          />

          <TextField
            label="Mobile Number"
            type="number"
            size="small"
            margin="dense"
            value={data?.number || ""}
            onChange={(e) => onChange("number", e.target.value)}
            sx={inputSty}
            InputLabelProps={{ sx: { fontWeight: "bold" } }}
          />
        </Box>
      )}
    </>
  );
};

export default MemberForm;
